module.exports = __webpack_public_path__ + "img/832.4c466eb3.svg";